import { useLang } from '@/i18n';
import EfCheckInActivities from '@elem/ui/ef-check-in-activities';
import styles from './index.module.scss';
import gtm from 'eco-design-reliance/gtm';
import { useEffect, useState } from 'react';
import { getIsLogin } from '@/utils/cookie';
import { signupCookie } from '@/utils/cookies/signupCookie';

const getTimeForAllBrowser = (value: string) => {
    if (!value) return '';
    if (typeof String.prototype.replaceAll === 'undefined') {
        return value.toString().replaceAll('-', '/');
    }
    return value.toString().replace(/\-/g, '/');
};
export default function Comp() {
    const { t } = useLang('theProduct.ActivityA2');
    const [campaignStatus, setCampaignStatus] = useState<string>();
    const [isLogin, setIsLogin] = useState(false);
    const [isDisabledAll, setIsDisabledAll] = useState(false); // 是否没到签到时间
    const saveScrollPosition = () => sessionStorage.setItem('scrollPosition', String(document.documentElement.scrollTop));

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        if (scrollPosition) {
            window.scrollTo({
                top: Number(scrollPosition),
                behavior: 'smooth',
            });
            sessionStorage.removeItem('scrollPosition');
        }
        return () => {
            sessionStorage.removeItem('scrollPosition');
        };
    }, []);
    return (
        <div className={styles.comp}>
            {campaignStatus === '1' && !isDisabledAll && (
                <div className="common-page-desc">
                    <span className="page-section-timer-icon"></span>
                    {t('desc')}
                </div>
            )}
            <EfCheckInActivities
                getMsgCallback={(data) => {
                    const { campaignStartTime, campaignEndTime, localCurrentTime } = data;
                    if (campaignStartTime && campaignEndTime) {
                        const date1 = new Date(getTimeForAllBrowser(campaignStartTime));
                        const date2 = new Date(getTimeForAllBrowser(campaignEndTime));
                        const date3 = new Date(getTimeForAllBrowser(localCurrentTime)) || new Date();
                        if (date3 < date1 || date3 > date2) {
                            setIsDisabledAll(true); //不在打卡时间内
                        }
                    }
                    setCampaignStatus(`${data?.campaignStatus || 0}`);
                }}
                callback={() => setIsLogin(true)}
            />
            {campaignStatus === '1' && !isDisabledAll && !isLogin && (
                <p className="ActivityA3-tips">
                    {t.rich('tips', {
                        line1: (children: any) => {
                            return (
                                <a
                                    className="ActivityA3-tips-line"
                                    onClick={() => {
                                        saveScrollPosition();
                                        window.location.href = `register?redirect=${encodeURIComponent(window.location.href)}`;
                                        signupCookie({ sector_name: t('desc'), entry_position: 8 });
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'click_sign_up_now',
                                            product_name: 'wave-3-and-glacier-classic',
                                        });
                                    }}
                                >
                                    {children}
                                </a>
                            );
                        },
                    })}
                </p>
            )}
        </div>
    );
}
